import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { OnProgressProps } from 'react-player/base';

interface PlayerProps {
  token: string;
  virtualFinishAt?: number;
  initialTime?: number;
  className?: string;
  onCreate?: (player: ReactPlayer) => void;
  onStart?: () => void;
  onFinish?: () => void;
  onVirtualFinish?: () => void;
  onError?: (error: any) => void;
  videoQuality: string
}

const PlayerVimeo: React.FC<PlayerProps> = ({
  token,
  initialTime = 0,
  className,
  onFinish,
  onStart,
  onError,
  onCreate,
  virtualFinishAt = 80,
  onVirtualFinish,
  videoQuality
}) => {
  const [videoUrl, setVideoUrl] = useState<string>('');
  const [firedVirtualFinish, setFiredVirtualFinish] = useState(false);
  const [progress, setProgress] = useState<OnProgressProps>();

  const PLAYBACK_RATE_KEY = 'at:playbackRate';
  const [playbackRate] = useState<number>(() => {
    const newPlaybackRate = localStorage.getItem(PLAYBACK_RATE_KEY);
    if (newPlaybackRate) {
      return parseFloat(newPlaybackRate);
    }

    return 1;
  });

  const updatePlaybackRate = (newPlaybackRate: number) => {
    localStorage.setItem(PLAYBACK_RATE_KEY, newPlaybackRate.toString());
  };

  useEffect(() => {
    if (token && token.includes('vimeo.com')) {
      setVideoUrl(token);
    } else {
      setVideoUrl(`https://vimeo.com/${token}`);
    }
  }, [token]);

  // https://github.com/CookPete/react-player#responsive-player

  useEffect(() => {
    if (onVirtualFinish && virtualFinishAt && !firedVirtualFinish && progress) {
      if (progress.played > virtualFinishAt / 100) {
        setFiredVirtualFinish(true);
        onVirtualFinish();
      }
    }
  }, [progress, virtualFinishAt, firedVirtualFinish, onVirtualFinish]);
  return (
    <div className={`relative bg-[#000] ${className ? className : ''}`}>
      <ReactPlayer
        className='react-player absolute left-0 top-0'
        width='100%'
        height='100%'
        url={videoUrl}
        controls={true}
        onProgress={(progress) => {
          setProgress(progress);
        }}
        onEnded={() => {
          onFinish && onFinish();
        }}
        onReady={(player) => {
          onCreate && onCreate(player);

          if (initialTime > 0) {
            player.seekTo(initialTime, 'seconds');
          }
        }}
        onStart={() => {
          onStart && onStart();
        }}
        onError={(error) => {
          onError && onError(error);
        }}
        playbackRate={playbackRate}
        onPlaybackRateChange={updatePlaybackRate}
        config={{
          vimeo: {
            playerOptions: {
              quality: videoQuality
            }
          }
        }}
        playsinline={true}
      />
    </div>
  );
};

export default PlayerVimeo;
